import React from "react";

export default function About() {
  return (
    <div className="container text-center mt-20 px-10">
      <h5 className="font-bold text-4xl text-green-700">Lorem ipsum dolor sit amet consectetur.</h5>

      <p className="mt-3">
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ad, beatae illo a excepturi, doloribus voluptate voluptatibus, labore voluptates reprehenderit recusandae sit commodi illum omnis tempora! Consequuntur quisquam obcaecati asperiores optio quaerat exercitationem voluptatibus numquam maiores officia expedita iure totam eaque eius odio, quod, tempora error ex commodi aliquam animi nam incidunt? Rem unde commodi asperiores exercitationem, illo modi dolorem ad omnis expedita harum doloremque obcaecati molestiae dolores numquam? Veniam eveniet beatae, ducimus, magnam expedita enim, mollitia unde praesentium atque ea ratione. Fugit repellat earum dolorem. Excepturi nisi voluptatum incidunt esse asperiores, facilis, eligendi doloremque vitae quidem tempora quasi provident dignissimos?
      </p>
    </div>
  );
}
